import { add, format } from 'date-fns';
import { price } from 'utils/helpers';
import { FORMAT_QT_DATE } from 'utils/helpers/datetime';

function next7Days(firstDay) {
  const result = [];
  for (let i = 0; i < 7; i++) {
    const d = add(firstDay, { days: i });
    result.push(d);
  }
  return result;
}

export function get7DaysStraight(firstDay) {
  const dateArray = next7Days(firstDay);
  const result = {};
  dateArray.forEach((item) => {
    const key = format(item, FORMAT_QT_DATE);
    result[key] = {
      value: item,
      dayOfWeek: format(item, 'EEE'),
      dayOfMonth: format(item, 'dd/MM'),
    };
  });
  return result;
}

export function transferToSeatMap(rawJson) {
  const dateArray = Object.keys(rawJson);
  const result = {};
  dateArray.forEach((item) => {
    result[item] = rawJson[item].available_units || 0;
  });
  return result;
}

export function transferToPriceMap(rawJson, defaultPrice) {
  const dateArray = Object.keys(rawJson);
  const result = {};
  dateArray.forEach((item) => {
    let cost = rawJson[item].seasonality?.passenger_pricing?.Adult;
    if (cost === undefined) {
      cost = defaultPrice ? price(defaultPrice, { omitZeroCents: true }) : '-';
    } else {
      cost = price(cost, { fromCents: true, omitZeroCents: true });
    }

    result[item] = {
      price: cost,
      available: rawJson[item].available,
    };
  });
  return result;
}

export function isSeasonalityAvailable(rawJson) {
  const arr = Object.values(rawJson);
  return arr.some((item) => item.seasonality?.passenger_pricing?.Adult);
}
